"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPlaylistContent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _molecules = require("../../molecules");

var _atoms = require("../../atoms");

require("./SelectPlaylistContent.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SelectPlaylistContent = function SelectPlaylistContent(_ref) {
  var collections = _ref.collections,
      user = _ref.user,
      addMomentToCollection = _ref.addMomentToCollection,
      createNewPlaylist = _ref.createNewPlaylist,
      createSuggestedPlaylist = _ref.createSuggestedPlaylist,
      lockPlaylists = _ref.lockPlaylists;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      showHomework = _useState2[0],
      setShowHomework = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showFamily = _useState4[0],
      setShowFamily = _useState4[1];

  var extractFirstName = function extractFirstName(name) {
    return name ? name.substr(0, name.indexOf(" ")) : "";
  };

  var _onClick = function onClick(collection, index) {
    if (!lockPlaylists) {
      addMomentToCollection(collection);
    } else {
      if (index < 2) {
        addMomentToCollection(collection);
      }
    }
  };

  (0, _react.useEffect)(function () {
    var homeworkFound = collections.find(function (collection) {
      return collection.title === 'Homework';
    });
    setShowHomework(!homeworkFound);
    var familyFound = collections.find(function (collection) {
      return collection.title === 'Family';
    });
    setShowFamily(!familyFound);
  }, [collections]);
  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "EditSpotlightContainer"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Heading5,
    content: "".concat(extractFirstName(user === null || user === void 0 ? void 0 : user.name), "'s playlist"),
    color: _atoms.Color.Grey2
  }), collections === null || collections === void 0 ? void 0 : collections.map(function (collection, index) {
    var isLocked = lockPlaylists && index > 1;
    return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      key: index,
      className: "playlist-info",
      trkAction: "Playlist Selected",
      onClick: function onClick() {
        return _onClick(collection, index);
      }
    }, /*#__PURE__*/_react.default.createElement(_atoms.Column, null, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      spacing: "4",
      className: "select-playlist-row"
    }, /*#__PURE__*/_react.default.createElement(_molecules.RoundButton, {
      icon: _atoms.Icon.Type.Add,
      color: isLocked ? _atoms.Color.Grey3 : _atoms.Color.Trace,
      iconColor: _atoms.Color.White2,
      backgroundColor: isLocked ? _atoms.Color.Grey3 : _atoms.Color.Trace,
      width: 32,
      height: 32
    }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      className: "playlist-name ".concat(!collection.public ? ' shorten-names' : '', " ").concat(isLocked ? ' unlock-names' : ''),
      type: _atoms.Label.Type.Body,
      content: collection.title,
      color: isLocked ? _atoms.Color.Grey3 : _atoms.Color.Black,
      marginLeft: "2"
    }))), !collection.public && !isLocked && /*#__PURE__*/_react.default.createElement(_atoms.Column, {
      className: "playlist-privacy-column"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      spacing: "4",
      className: "playlist-privacy"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: 16,
      type: _atoms.Icon.Type.Lock,
      color: _atoms.Color.Grey2
    }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.Body,
      content: "Private",
      color: _atoms.Color.Grey2,
      marginLeft: "1"
    }))), isLocked && /*#__PURE__*/_react.default.createElement(_atoms.Column, {
      className: "playlist-privacy-column"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      spacing: "4",
      className: "playlist-privacy"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.Body,
      content: "Unlock with Plus",
      color: _atoms.Color.Grey2,
      marginLeft: "1"
    }))));
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Heading5,
    content: "Suggested playlists",
    color: _atoms.Color.Grey2,
    marginTop: "6"
  }), showHomework && /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "playlist-info"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, null, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    spacing: "4",
    trkAction: "Create Homework Playlist",
    onClick: function onClick() {
      return createSuggestedPlaylist('Homework');
    },
    className: "select-playlist-row"
  }, /*#__PURE__*/_react.default.createElement(_molecules.RoundButton, {
    icon: _atoms.Icon.Type.Add,
    color: _atoms.Color.Trace,
    iconColor: _atoms.Color.Trace,
    backgroundColor: _atoms.Color.Transparent,
    width: 32,
    height: 32
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "playlist-name",
    type: _atoms.Label.Type.Body,
    content: "Homework",
    color: _atoms.Color.Black,
    marginLeft: "2"
  })))), showFamily && /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "playlist-info"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, null, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    spacing: "4",
    trkAction: "Create Family Playlist",
    onClick: function onClick() {
      return createSuggestedPlaylist('Family');
    },
    className: "select-playlist-row"
  }, /*#__PURE__*/_react.default.createElement(_molecules.RoundButton, {
    icon: _atoms.Icon.Type.Add,
    color: _atoms.Color.Trace,
    iconColor: _atoms.Color.Trace,
    backgroundColor: _atoms.Color.Transparent,
    width: 32,
    height: 32
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "playlist-name",
    type: _atoms.Label.Type.Body,
    content: "Family",
    color: _atoms.Color.Black,
    marginLeft: "2"
  })))), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "playlist-info"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, null, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    spacing: "4",
    trkAction: "Create New Playlist",
    onClick: function onClick() {
      return createNewPlaylist();
    },
    className: "select-playlist-row"
  }, /*#__PURE__*/_react.default.createElement(_molecules.RoundButton, {
    icon: _atoms.Icon.Type.Add,
    color: _atoms.Color.Trace,
    iconColor: _atoms.Color.Trace,
    backgroundColor: _atoms.Color.Transparent,
    width: 32,
    height: 32
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "playlist-name",
    type: _atoms.Label.Type.Body,
    content: "Create a custom playlist",
    color: _atoms.Color.Black,
    marginLeft: "2"
  })))));
};

exports.SelectPlaylistContent = SelectPlaylistContent;